
/* @jsx jsx */
import React from 'react' // eslint-disable-line
import { jsx, css } from '@emotion/core'


const style = () => css`
  border: 0;
  display: flex;
  font-size: 13px;
  padding: 0 8px;
`
const props = {
  'data-inputter': 'bar',
}

export default { style, props }
